import { Link } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const NAV = [
  { to: "/features", label: "Features" },
  { to: "/pricing", label: "Pricing" },
  { to: "/gst-billing", label: "GST Billing" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

export default function PublicHeader() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 glass border-b border-border/60">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 h-16 flex items-center gap-6">
        <Link to="/" className="flex items-center gap-2 font-heading font-bold">
          <div className="w-9 h-9 rounded-lg bg-primary text-primary-foreground grid place-items-center text-sm">BP</div>
          <span className="text-lg">TheBillPro</span>
        </Link>
        <nav className="hidden md:flex items-center gap-1 ml-6">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="px-3 py-1.5 rounded-md text-sm text-muted-foreground hover:text-foreground hover:bg-muted transition-colors">
              {n.label}
            </Link>
          ))}
        </nav>
        <div className="ml-auto flex items-center gap-2">
          <Link to="/login" className="text-sm text-muted-foreground hover:text-foreground hidden sm:inline" data-testid="nav-login">Login</Link>
          <Button asChild data-testid="nav-signup">
            <Link to="/signup">Start Free Trial</Link>
          </Button>
          <button className="md:hidden ml-1" onClick={() => setOpen(!open)} aria-label="Menu">
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>
      {open && (
        <div className="md:hidden border-t border-border/60 bg-background">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} onClick={() => setOpen(false)}
              className="block px-6 py-3 text-sm hover:bg-muted">{n.label}</Link>
          ))}
          <Link to="/login" className="block px-6 py-3 text-sm hover:bg-muted">Login</Link>
        </div>
      )}
    </header>
  );
}
